module.exports = __webpack_public_path__ + "static/media/DevMountain - Hexagon.e4fdad0e.png";